import { Helmet } from 'react-helmet-async'
import { identity } from '../data/profile'
import { SERVICE_ID, professionalServiceSchema } from '../lib/structuredData'

export { PERSON_ID, personSchema, professionalServiceSchema } from '../lib/structuredData'

/**
 * Structured Data Component for SEO
 * Adds JSON-LD schema markup for rich snippets
 */
export default function StructuredData({ data }) {
  if (!data) return null

  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(data)}</script>
    </Helmet>
  )
}


// Old pages (removed in the WEB-1 deletion slices) still import the helpers below.
export { professionalServiceSchema as OrganizationSchema }

/**
 * Generate article schema for blog posts
 */
export function ArticleSchema({ title, description, publishDate, author, url }) {
  return {
    '@context': 'https://schema.org',
    '@type': 'Article',
    headline: title,
    description: description,
    datePublished: publishDate,
    author: {
      '@type': 'Person',
      name: author || identity.name,
    },
    publisher: { '@id': SERVICE_ID },
    mainEntityOfPage: {
      '@type': 'WebPage',
      '@id': url,
    },
  }
}

/**
 * Generate BreadcrumbList schema
 */
export function BreadcrumbSchema({ items }) {
  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: item.name,
      item: item.url,
    })),
  }
}

/**
 * Generate FAQPage schema
 */
export function FAQPageSchema({ questions }) {
  return {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: questions.map((q) => ({
      '@type': 'Question',
      name: q.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: q.answer,
      },
    })),
  }
}

// Export alias for compatibility
export { FAQPageSchema as FAQSchema }

/**
 * Generate SpeakableSpecification schema (for accessibility)
 */
export function SpeakableSchema({ cssSelectors }) {
  return {
    '@context': 'https://schema.org',
    '@type': 'SpeakableSpecification',
    cssSelector: cssSelectors,
  }
}
